// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-r{position:relative;-webkit-user-select:none;user-select:none;touch-action:pan-y}.isPrevent{pointer-events:none}.swiper-r__wrap{overflow:hidden}.swiper-r__slides{position:relative;display:flex;flex-wrap:nowrap}.swiper-r__container{justify-content:space-between}.swiper-r__container,.swiper-r__container-arrows{display:flex;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
